import axios from "@/api/axiosAuthRequired.js"
import { SUBSCRIPTIONS_GAMES } from "../game/game.constants"
import ESTIMATOR_GAMES from "@/store/data/marketing/games-rank-predictor"
import Bar1 from "@/assets/animations/start_animations/bars/bar1"
import Bar2 from "@/assets/animations/start_animations/bars/bar2"
import Bar3 from "@/assets/animations/start_animations/bars/bar3"
import Bar4 from "@/assets/animations/start_animations/bars/bar4"
import Fire from "@/assets/animations/start_animations/fire.json"
import Vue from "vue"
import { getCoursesForCheckout } from "@/api/course"
import { MIXINS } from "@/utils/mixins"

const state = {
  currentStep: "landing",
  games: SUBSCRIPTIONS_GAMES,
  showOpeningAnimation: true,
  selectedGame: null,
  activeEstimatorFields: null,
  selectedEstimatorValues: {},
  results: {
    kd1: null,
    kd2: null,
    kd3: null,
    kd4: null,
    rankImage1: null,
    rankImage2: null,
    rankImage3: null,
    rankImage4: null,
    rankEstimateTime1: null,
    rankEstimateTime2: null,
    rankEstimateTime3: null,
    rankEstimateTime4: null,
    rankEstimateRank1: null,
    rankEstimateRank2: null,
    rankEstimateRank3: null,
    rankEstimateRank4: null,
    Bar1: Bar1,
    Bar2: Bar2,
    Bar3: Bar3,
    Bar4: Bar4,
    Fire: Fire,
    showBar1: false,
    showBar2: false,
    showBar3: false,
    showBar4: false,
    estimatorResult: null,
  },
  courses: [],
}
const getters = {
  currentStep: state => state.currentStep,
  games: state => state.games,
  showOpeningAnimation: state => state.showOpeningAnimation,
  selectedGame: state => state.selectedGame,
  results: state => state.results,
  courses: state => state.courses,
  activeEstimatorFields: state => {
    if (state.selectedGame) {
      const gameKey = state.selectedGame.key
      return ESTIMATOR_GAMES[gameKey]
    } else {
      return null
    }
  },
  selectedEstimatorValues: state => state.selectedEstimatorValues,
}
const mutations = {
  setCurrentStep: (state, step) => (state.currentStep = step),
  setShowOpeningAnimation: (state, showOpeningAnimation) =>
    (state.showOpeningAnimation = showOpeningAnimation),
  setSelectedGame: (state, selectedGame) => (state.selectedGame = selectedGame),
  setResults: (state, results) => (state.results = results),
  setSelectedEstimatorValues: (state, values) =>
    (state.selectedEstimatorValues = values),
  setCourses: (state, courses) => (state.courses = courses),
}
const actions = {
  resetResults ({ commit }) {
    const results = {
      rankImage1: null,
      rankImage2: null,
      rankImage3: null,
      rankImage4: null,
      rankEstimateTime1: null,
      rankEstimateTime2: null,
      rankEstimateTime3: null,
      rankEstimateTime4: null,
      rankEstimateRank1: null,
      rankEstimateRank2: null,
      rankEstimateRank3: null,
      rankEstimateRank4: null,
      Bar1: Bar1,
      Bar2: Bar2,
      Bar3: Bar3,
      Bar4: Bar4,
      Fire: Fire,
      showBar1: false,
      showBar2: false,
      showBar3: false,
      showBar4: false,
      estimatorResult: null,
    }
    commit("setResults", results)
  },
  setResultField ({ commit, state }, { field, value }) {
    const results = state.results
    results[field] = value
    commit("setResults", results)
  },
  selectGame ({ commit, dispatch }, game) {
    if (game.status !== "available") {
      return
    }
    commit("setSelectedGame", game)
    dispatch("resetResults")
  },
  setSelectedEstimatorOption (
    { state, commit, getters, dispatch },
    { game, field, value }
  ) {
    const selectedEstimatorValues = state.selectedEstimatorValues
    let gameKey = game.key
    let fieldValue = {}
    fieldValue[field] = value
    Vue.prototype.$set(
      selectedEstimatorValues,
      gameKey,
      Object.assign(
        {},
        Vue.prototype.$_.get(selectedEstimatorValues, gameKey, {}),
        fieldValue
      )
    )
    commit("setSelectedEstimatorValues", selectedEstimatorValues)
    if (
      Object.keys(selectedEstimatorValues[gameKey]).length ===
      getters["activeEstimatorFields"].length
    ) {
      dispatch("startEstimator")
    }
  },
  startEstimator ({ state, dispatch }) {
    let proficiencyLevel = "unknown"
    const selectedOptions =
      state.selectedEstimatorValues[state.selectedGame.key]
    dispatch("setResultField", { field: "loading", value: true })
    switch (state.selectedGame.key) {
      case "leagueoflegends":
        const league = selectedOptions.selectInput
        const leagueDivision = selectedOptions.secondarySelectInput
        if (["iron", "bronze", "silver"].includes(league)) {
          proficiencyLevel = "low"
        } else if (["gold"].includes(league)) {
          proficiencyLevel = "medium"
        } else if (["platinum"].includes(league)) {
          if (["i", "ii"].includes(leagueDivision)) {
            proficiencyLevel = "high"
          } else {
            proficiencyLevel = "medium"
          }
        } else if (["diamond"].includes(league)) {
          proficiencyLevel = "high"
        }
        break
      case "hearthstone":
        const hearthstoneRank = parseInt(selectedOptions.selectInput)
        if (hearthstoneRank > 10) {
          proficiencyLevel = "low"
        } else if (hearthstoneRank > 5) {
          proficiencyLevel = "medium"
        } else {
          proficiencyLevel = "high"
        }
        break
      case "fortnite":
        const fortniteKdr = selectedOptions.selectInput
        if (["< 0.25", "0.25", "0.50", "0.75"].includes(fortniteKdr)) {
          proficiencyLevel = "low"
        } else if (["1.00", "2.00"].includes(fortniteKdr)) {
          proficiencyLevel = "medium"
        } else if (["3.00", "4.00"].includes(fortniteKdr)) {
          proficiencyLevel = "high"
        }
        const fortniteDivision = selectedOptions.selectInput
        if (["d1", "d2"].includes(fortniteDivision)) {
          proficiencyLevel = "low"
        } else if (["d3", "d4"].includes(fortniteDivision)) {
          proficiencyLevel = "medium"
        } else if (["d5", "d6"].includes(fortniteDivision)) {
          proficiencyLevel = "high"
        }
        break
      case "csgo":
        const csgoRank = selectedOptions.selectInput
        if (
          [
            "Silver I",
            "Silver II",
            "Silver III",
            "Silver IV",
            "Silver Elite",
            "Silver Elite Master",
            "Gold Nova I",
            "Gold Nova II",
            "Gold Nova III",
            "Gold Nova Master",
          ].includes(csgoRank)
        ) {
          proficiencyLevel = "low"
        } else if (
          [
            "Master Guardian I",
            "Master Guardian II",
            "Master Guardian Elite",
          ].includes(csgoRank)
        ) {
          proficiencyLevel = "medium"
        } else if (
          [
            "Distinguished Master Guardian",
            "Legendary Eagle",
            "Legendary Eagle Master",
            "Supreme Master First Class",
          ].includes(csgoRank)
        ) {
          proficiencyLevel = "high"
        }
        break
    }

    // Analytics: Rank predictor usage
    MIXINS.methods.trackAnalyticsEvent("Predict Rank", {
      game_type: state.selectedGame.key,
      proficiency_level: proficiencyLevel,
    })

    let body = new FormData()
    body.append("game", state.selectedGame.key)
    body.append("options[selectInput]", selectedOptions.selectInput)
    if (selectedOptions.secondarySelectInput) {
      body.append(
        "options[secondarySelectInput]",
        selectedOptions.secondarySelectInput
      )
    }

    axios({
      method: "post",
      url: "/functions/game-progression/estimate-progression.php",
      data: body,
    })
      .then(response => {
        let data = response.data
        dispatch("setResultField", { field: "loading", value: false })
        if (data.status === "success") {
          dispatch("setResultField", {
            field: "estimatorResult",
            value: data.data,
          })
          if (state.selectedGame.key === "fortnite") {
            dispatch("setResultField", { field: "kd1", value: data.data[0].kd })
            dispatch("setResultField", { field: "kd2", value: data.data[1].kd })
            dispatch("setResultField", { field: "kd3", value: data.data[2].kd })
            dispatch("setResultField", { field: "kd4", value: data.data[3].kd })
          }
          dispatch("setResultField", {
            field: "rankImage1",
            value: data.data[0].icon,
          })
          dispatch("setResultField", {
            field: "rankImage2",
            value: data.data[1].icon,
          })
          dispatch("setResultField", {
            field: "rankImage3",
            value: data.data[2].icon,
          })
          dispatch("setResultField", {
            field: "rankImage4",
            value: data.data[3].icon,
          })
          dispatch("setResultField", {
            field: "rankEstimateTime1",
            value: "START",
          })
          dispatch("setResultField", {
            field: "rankEstimateTime2",
            value: data.data[1].proDuration,
          })
          dispatch("setResultField", {
            field: "rankEstimateTime3",
            value: data.data[2].proDuration,
          })
          dispatch("setResultField", {
            field: "rankEstimateTime4",
            value: data.data[3].proDuration,
          })
          dispatch("setResultField", {
            field: "rankEstimateRank1",
            value: data.data[0].label,
          })

          dispatch("setResultField", {
            field: "rankEstimateRank2",
            value: data.data[1].label,
          })
          dispatch("setResultField", {
            field: "rankEstimateRank3",
            value: data.data[2].label,
          })
          dispatch("setResultField", {
            field: "rankEstimateRank4",
            value: data.data[3].label,
          })
          setTimeout(() => {
            dispatch("startBarAnimations")
          }, 2000)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  startBarAnimations ({ dispatch }) {
    dispatch("setResultField", { field: "showBar1", value: true })
    setTimeout(() => {
      dispatch("setResultField", { field: "showBar2", value: true })
      setTimeout(() => {
        dispatch("setResultField", { field: "showBar3", value: true })
        setTimeout(() => {
          dispatch("setResultField", { field: "showBar4", value: true })
        }, 500)
      }, 500)
    }, 500)
  },
  async getCoursesForCheckout ({ commit }) {
    const data = await getCoursesForCheckout()
    commit("setCourses", data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions.js